// ======================================================
// IMA LANDING PAGE
// Conteúdo institucional revisado conforme orientações
// do documento de adequação do site.
// ======================================================


// ======================================================
// HERO
// ======================================================

export const heroData = {
  title: "Instituto Mercosul Amazônia",

  subtitle:
    "Inovação, desenvolvimento e conexões para a Amazônia",

  description:
    "Desenvolvemos projetos, programas e articulações que conectam inovação, empreendedorismo, ciência, tecnologia e desenvolvimento territorial na Amazônia.",

  ctaText: "Conheça nossas iniciativas",

  logo:
    "https://customer-assets.emergentagent.com/job_40c86c6d-2b74-4d54-8e62-bf8382c59aa6/artifacts/4bpiwzen_0cf8f0f6-8c2c-4700-b404-8a52d39933d6.jpeg",
};


// ======================================================
// SOBRE
// ======================================================
export const aboutData = {
  title: "Sobre o IMA",

  description:
    "O Instituto Mercosul Amazônia – IMA é uma organização da sociedade civil sediada em Rio Branco, Acre, que atua na construção de soluções para o desenvolvimento da Amazônia por meio da inovação, ciência, tecnologia, empreendedorismo e bioeconomia.",

  complementaryDescription:
    "Desde 2020, o IMA desenvolve e executa projetos, programas e ambientes de inovação que conectam poder público, empresas, universidades, empreendedores e comunidades, transformando conhecimento e oportunidades em desenvolvimento econômico e impacto para o território.",

  mission:
    "Impulsionar o desenvolvimento da Amazônia por meio da inovação, do empreendedorismo, da ciência e da tecnologia.",

  values: [
    {
      icon: "Lightbulb",
      title: "Inovação",
      description:
        "Transformamos conhecimento, tecnologia e criatividade em soluções para os desafios da Amazônia.",
    },
    {
      icon: "TrendingUp",
      title: "Desenvolvimento",
      description:
        "Criamos oportunidades, fortalecemos negócios e impulsionamos o desenvolvimento dos territórios amazônicos.",
    },
    {
      icon: "Users",
      title: "Conexão",
      description:
        "Conectamos governo, empresas, universidades, empreendedores e comunidades para transformar ideias em impacto.",
    },
  ],
};


// ======================================================
// INOVAÇÃO QUE GERA DESENVOLVIMENTO
// ======================================================

export const innovationData = {
  title: "Inovação que gera desenvolvimento",

  description:
    "Acreditamos na inovação como instrumento de transformação econômica, social e territorial da Amazônia.",

  initiatives: [
    "Empreendedorismo e desenvolvimento de negócios",
    "Incubação e aceleração de projetos inovadores",
    "Ciência, tecnologia e inovação",
    "Pesquisa, desenvolvimento e prototipagem",
    "Formação e capacitação",
    "Ambientes e ecossistemas de inovação",
    "Bioeconomia e desenvolvimento sustentável",
    "Articulação entre governo, empresas, universidades e sociedade",
  ],
};


// ======================================================
// ÁREAS DE ATUAÇÃO
// ======================================================

export const areasAtuacaoIntro = {
  title: "Áreas de Atuação do IMA",

  description:
    "Nosso trabalho integra inovação, empreendedorismo, ciência e desenvolvimento para criar novas oportunidades e fortalecer os territórios amazônicos.",
};

export const areasAtuacao = [
  {
    icon: "Cpu",
    title: "Inovação, Ciência e Tecnologia",
    description:
      "Desenvolvemos e apoiamos projetos, programas e ambientes que aproximam ciência, tecnologia e inovação dos desafios e oportunidades da Amazônia.",
    highlight: "Inovação que transforma",
  },
  {
    icon: "BriefcaseBusiness",
    title: "Empreendedorismo e Desenvolvimento de Negócios",
    description:
      "Criamos iniciativas de formação, incubação, aceleração e apoio ao desenvolvimento de empreendedores, startups e negócios inovadores.",
    highlight: "Negócios que geram oportunidades",
  },
  {
    icon: "Network",
    title: "Ecossistemas e Desenvolvimento Territorial",
    description:
      "Conectamos governo, empresas, universidades, empreendedores e sociedade para fortalecer ecossistemas de inovação e impulsionar o desenvolvimento dos territórios.",
    highlight: "Conexões que geram desenvolvimento",
  },
  {
    icon: "Leaf",
    title: "Bioeconomia e Sustentabilidade",
    description:
      "Promovemos iniciativas que valorizam os ativos e conhecimentos da Amazônia, conectando inovação, geração de renda e desenvolvimento sustentável.",
    highlight: "Amazônia como oportunidade",
  },
];


// ======================================================
// PROJETOS E INICIATIVAS
// ======================================================

export const projectsIntro = {
  title: "Projetos e Iniciativas",

  subtitle:
    "Conheça algumas das iniciativas desenvolvidas e executadas pelo IMA para fortalecer a inovação e o desenvolvimento da Amazônia.",
};

export const projetos = [
  {
    title: "Tecnosfera",

    area:
      "Educação, inovação e tecnologia",

    category:
      "Educação e Tecnologia",

    description:
      "Projeto de educação, inovação e tecnologia voltado à aproximação de estudantes com novas tecnologias, cultura digital e possibilidades profissionais.",

    /*
     * O documento não informa o status atual.
     * Preencher somente após confirmação institucional.
     */
    status: null,

    role:
      "Realização e execução pelo IMA",

    /*
     * Exibir somente quando houver indicador
     * documentado e comprovável.
     */
    impact: null,

    link: null,
  },

  {
    title: "Inova Aquiri",

    area:
      "Ecossistemas de inovação",

    category:
      "Inovação e Empreendedorismo",

    description:
      "Iniciativa voltada ao fortalecimento do ecossistema de inovação, empreendedorismo, tecnologia e desenvolvimento sustentável.",

    status: null,

    role:
      "Realização, articulação e execução pelo IMA",

    impact: null,

    link: null,
  },

  {
    title: "Protagonismo Colaborativo",

    area:
      "Desenvolvimento institucional e terceiro setor",

    category:
      "Terceiro Setor",

    description:
      "Programa de fortalecimento de organizações comunitárias e do terceiro setor, com diagnóstico, qualificação, elaboração de projetos e desenvolvimento institucional.",

    status: null,

    role:
      "Realização e execução pelo IMA",

    impact: null,

    link: null,
  },

  {
    title: "Nunca Foi Só Batom",

    area:
      "Empreendedorismo feminino",

    category:
      "Empreendedorismo",

    description:
      "Programa de desenvolvimento de negócios liderados por mulheres, com capacitação, consultoria, inovação, tecnologia, marketing e fortalecimento empresarial.",

    status: null,

    role:
      "Realização e execução pelo IMA",

    impact: null,

    link: null,
  },

  {
    title: "CAPTAR",

    area:
      "Captação de recursos e desenvolvimento de projetos",

    category:
      "Desenvolvimento de Negócios",

    description:
      "Programa de apoio a empreendedores e empresas para identificação de oportunidades de fomento, estruturação de projetos e acesso a recursos públicos e privados.",

    status: null,

    role:
      "Realização e execução pelo IMA",

    impact: null,

    link: null,
  },

  {
    title: "Empresário Profissional",

    area:
      "Desenvolvimento empresarial",

    category:
      "Empreendedorismo",

    description:
      "Programa itinerante de consultoria, capacitação e desenvolvimento empresarial voltado especialmente aos empreendedores do interior do Acre.",

    status: null,

    role:
      "Realização e execução pelo IMA",

    impact: null,

    link: null,
  },

  {
    title: "Polo Digital",

    area:
      "Formação e inclusão digital",

    category:
      "Tecnologia e Educação",

    description:
      "Iniciativa de formação e inclusão digital por meio de capacitações em tecnologia e informática.",

    status: null,

    role:
      "Realização e execução pelo IMA",

    impact: null,

    link: null,
  },

  {
    title: "Arena Gamer / Games e Economia Criativa",

    area:
      "Games, tecnologia, juventude e economia criativa",

    category:
      "Tecnologia e Economia Criativa",

    description:
      "Projetos e ações voltados ao fortalecimento do setor de games, e-sports, tecnologia, juventude e economia criativa.",

    status: null,

    /*
     * O documento ressalta que o papel pode variar
     * conforme a ação e instituições envolvidas.
     */
    role:
      "Realização, execução, parceria ou apoio, conforme cada ação desenvolvida",

    impact: null,

    link: null,
  },
];


// ======================================================
// EXPERIÊNCIAS / PROJETOS ESPECIAIS
// ======================================================

export const specialProjects = [
  {
    title: "Comic Nerd",

    area:
      "Cultura, tecnologia e economia criativa",

    category:
      "Cultura e Economia Criativa",

    /*
     * O documento apenas autoriza a inclusão como
     * experiência especial e não fornece descrição
     * institucional detalhada.
     */
    description:
      "Iniciativa vinculada à trajetória de ações do IMA nos campos de cultura, tecnologia, juventude e economia criativa.",

    status: null,

    role:
      "Participação do IMA conforme a iniciativa",

    impact: null,

    link: null,
  },

  {
    title: "ExpoGO",

    area:
      "Tecnologia, inovação e eventos",

    category:
      "Tecnologia e Inovação",

    description:
      "Experiência vinculada às ações de inovação, tecnologia e desenvolvimento de ambientes de interação realizadas ou apoiadas pelo IMA.",

    status: null,

    role:
      "Participação do IMA conforme a iniciativa",

    impact: null,

    link: null,
  },
];


// ======================================================
// CTA ANTES / APÓS PROJETOS
// ======================================================

export const projectsCta = {
  title:
    "Vamos transformar a Amazônia juntos?",

  description:
    "Conectamos pessoas, organizações e oportunidades para desenvolver soluções que geram inovação, desenvolvimento e impacto na Amazônia.",

  ctaText:
    "Fale com o IMA",
};


// ======================================================
// PARCEIROS E CONEXÕES
// ======================================================

export const partnersIntro = {
  title:
    "Parceiros e conexões que constroem nossa trajetória",

  description:
    "Ao longo de sua trajetória, o IMA tem desenvolvido projetos, ações, parcerias e articulações com instituições públicas, empresas, universidades e organizações do ecossistema de inovação.",

  disclaimer:
    "As instituições apresentadas representam conexões construídas ao longo da trajetória do IMA por meio de projetos, ações, articulações, apoios e iniciativas desenvolvidas em diferentes momentos. A presença nesta seção não indica, necessariamente, parceria institucional atualmente vigente.",
};


// ======================================================
// INSTITUIÇÕES RELACIONADAS À TRAJETÓRIA DO IMA
//
// IMPORTANTE:
// Inserir somente logotipos oficiais.
// Não utilizar badges/status como "Parceria Ativa".
// ======================================================

export const parceiros = [
  {
    name: "Governo do Estado do Acre",
    logo: null,
  },
  {
    name: "Governo Federal",
    logo: null,
  },
  {
    name: "Ministério da Ciência, Tecnologia e Inovação – MCTI",
    logo: null,
  },
  {
    name: "SEICT",
    logo: null,
  },
  {
    name: "SEGOV",
    logo: null,
  },
  {
    name: "Fundação Elias Mansour – FEM",
    logo: null,
  },
  {
    name: "CNPq",
    logo: null,
  },
  {
    name: "FIEAC",
    logo: null,
  },
  {
    name: "Sebrae Acre",
    logo: null,
  },
  {
    name: "UFAC",
    logo: null,
  },
  {
    name: "IFAC",
    logo: null,
  },
  {
    name: "OAB Acre",
    logo: null,
  },
  {
    name: "Impact Hub Manaus",
    logo: null,
  },
  {
    name: "Headscon / Instituto Gamecon",
    logo: null,
  },
  {
    name: "ANAC Nerd",
    logo: null,
  },
  {
    name: "Sem Fronteiras",
    logo: null,
  },
  {
    name: "ACECS",
    logo: null,
  },
  {
    name: "ACISA",
    logo: null,
  },
  {
    name: "IEL Acre",
    logo: null,
  },
  {
    name: "Prefeitura de Cruzeiro do Sul",
    logo: null,
  },
  {
    name: "Aquiri Valley",
    logo: null,
  },
  {
    name: "Juruá Valley",
    logo: null,
  },
  {
    name: "Tucupi Valley",
    logo: null,
  },
  {
    name: "Gran Sistemas",
    logo: null,
  },
];


// ======================================================
// CONTATO
// ======================================================

export const contactData = {
  title: "Contato",

  description:
    "Entre em contato com o Instituto Mercosul Amazônia para conhecer nossas iniciativas, construir conexões e desenvolver novas oportunidades para a Amazônia.",

  address: {
    street: "Avenida Ceará, 388 - Habitasa",
    cep: "CEP 69905-088",
    city: "Rio Branco, Acre",
  },

  /*
   * Preencher apenas após confirmação dos canais
   * institucionais oficiais.
   *
   * Os componentes já estão preparados para ocultar
   * essas informações enquanto estiverem null.
   */
  phone: null,

  email: null,

  whatsapp: null,

  social: {
    linkedin: null,
    instagram: null,
    facebook: null,
  },
};


// ======================================================
// FOOTER
// ======================================================

export const footerData = {
  organization:
    "Instituto Mercosul Amazônia",

  tagline:
    "Inovação, desenvolvimento e conexões para a Amazônia",

  description:
    "O IMA desenvolve projetos, programas e articulações que conectam inovação, empreendedorismo, ciência, tecnologia e desenvolvimento territorial na Amazônia.",

  missionTitle:
    "Nossa Missão",

  mission:
    "Impulsionar o desenvolvimento sustentável da Amazônia conectando pessoas, conhecimento, inovação e oportunidades.",

  quickLinks: [
    {
      label: "Home",
      id: "hero",
    },
    {
      label: "Sobre",
      id: "about",
    },
    {
      label: "Áreas de Atuação",
      id: "areas",
    },
    {
      label: "Projetos",
      id: "projects",
    },
    {
      label: "Parceiros",
      id: "partners",
    },
    {
      label: "Contato",
      id: "contact",
    },
  ],
};


// ======================================================
// INDICADORES
// ======================================================

/*
 * Não existem indicadores gerais comprovados no material
 * fornecido que possam substituir com segurança os números
 * fictícios anteriormente usados.
 *
 * Foram removidos:
 *
 * - 50+ startups aceleradas
 * - 15 patentes registradas
 * - 1.200+ pessoas capacitadas
 * - 100 mil hectares protegidos/monitorados
 *
 * Manter vazio até existirem números documentados
 * e institucionalmente validados.
 *
 * A exportação é mantida apenas para compatibilidade com
 * componentes antigos que ainda possam importar impactNumbers.
 */
export const impactNumbers = [];